import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import {toBoolean} from '../core/convert';


@Component({
  selector   : 'jd-option',
  templateUrl: './jd-option.component.html'
})
export class JdOptionComponent {
  private _disabled = false;
  private _customContent = false;
  @ViewChild(TemplateRef) template: TemplateRef<void>;
  @Input() jdLabel: string;
  @Input() jdK: string;
  // tslint:disable-next-line:no-any
  @Input() jdValue: any;

  @Input()
  set jdDisabled(value: boolean) {
    this._disabled = toBoolean(value);
  }

  get jdDisabled(): boolean {
    return this._disabled;
  }

  @Input()
  set jdCustomContent(value: boolean) {
    this._customContent = toBoolean(value);
  }

  get jdCustomContent(): boolean {
    return this._customContent;
  }
}
